import { DownloadSimple } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { useAgGridClientTableContext } from 'core/states';
import { Variant } from 'theme/enums';

// The exported columns read as the grid shows them: the status label and the version as "v1".
const DOWNLOADED_COLUMN_IDS = [
  'id',
  'name',
  'attributesCount',
  'familiesCount',
  'status',
  'versionNumber',
];

// The selected product types as a CSV file, built from the grid itself.
export const DownloadPartFinderProductTypesButton = () => {
  const { t } = useTranslation();

  const { gridApi } = useAgGridClientTableContext();

  const onDownload = () =>
    gridApi?.exportDataAsCsv({
      onlySelected: true,
      columnKeys: DOWNLOADED_COLUMN_IDS,
      fileName: `${t('titlePartFinderProductTypes')}.csv`,
    });

  return (
    <Button
      text={t('buttonLabelDownload')}
      variant={Variant.SOFT}
      startDecorator={<DownloadSimple />}
      onClick={onDownload}
    />
  );
};
